import React, { useEffect } from 'react';
import IconArrowRight from 'venuescanner-js/react/components/Objects/Icons/IconArrowRight';
import IconContact from 'venuescanner-js/react/components/Objects/Icons/IconContact';
import './ContactButton.scss';

export const ContactButton = ({ isMobileDevice, venue }) => {
  const onClick = () => {
    window.Intercom('show');
  };
  return isMobileDevice ? (
    <div className='contact-button'>
      <div className='contact-button_container'>
        <div className='contact-button_icon'>
          <IconContact aria-hidden='true' focusable='false' onClick={onClick} />
        </div>
        <span className='contact-button_contact-text_title' onClick={onClick}>
          Need help?
          <p>Contact our customer support </p>
        </span>
      </div>
      <div className='contact-button__arrow'>
        <IconArrowRight onClick={onClick} />
      </div>
    </div>
  ) : (
    <div className='contact-button'>
      <div className='contact-button_icon' onClick={onClick}>
        <IconContact aria-hidden='true' focusable='false' />
      </div>
      <div className='contact-button_contact-text' onClick={onClick}>
        <span className='contact-button_contact-text_title'>Need help?</span>
        <p>Contact our customer support</p>
      </div>
    </div>
  );
};
